/* 
*  Created by SGiri 06/29/2018
*/

import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MaterialModule } from "../material/material.module";
import { RequestComponent } from "~admin/request/request.component";
import { ActionComponent } from "~admin/action/action.component";
import { ActionDialogComponent } from "~admin/action-dialog/action-dialog.component";
import { NewrequestComponent } from "~admin/newrequest/newrequest.component";
import { TextinputComponent } from "~admin/textinput/textinput.component";
import { DatasourceComponent } from "~admin/datasource/datasource.component";
import { BulkCreateComponent } from "~admin/datasource/bulk-create/bulk-create.component";
import { AgGridModule } from "ag-grid-angular";
import { InfoDialogComponent } from "../info-dialog/info-dialog.component";
import { AdminService } from "~admin/services/admin.service";
import { ListdatasourceComponent } from "~admin/datasource/listdatasource/listdatasource.component";

@NgModule({
    declarations: [
        RequestComponent,
        ActionComponent,
        ActionDialogComponent,
        NewrequestComponent,
        TextinputComponent,
        DatasourceComponent,
        BulkCreateComponent,
        ListdatasourceComponent
    ],
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        MaterialModule,
        AgGridModule.withComponents(
            [ActionComponent, TextinputComponent, BulkCreateComponent]
        ),
    ],
    entryComponents: [
        ActionDialogComponent,
        InfoDialogComponent
    ],
    providers: [
        AdminService
    ],
})
export class AdmingModule {
}



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/bi-admin/bi-admin.module.ts